export const environment = {
  production: false,

  // OpenAI — nur noch für DALL-E Image Generation + Stella Embeddings
  openaiApiKey: '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',

  // Anthropic — direkter Claude-Call (generateWeekPlan, generateSingleSlide etc.)
  anthropicApiKey: '',  // LEER lassen, Prod-Key nur via Worker/Backend

  // Stella Social Worker — Post/Caption/Slides Generierung
  stellaSocialUrl: 'https://stella-social.stonewavetech.workers.dev',
  stellaSocialSecret: 'b025d8b8-ef99-4370-aedb-1c9d66730724',

  // Stella V2 — Agentic /run + /feedback (eval loop)
  stellaV2Url: 'https://stella-v2.stonewavetech.workers.dev',

  // Instagram
  instagramAccessToken: 'EAASaxtYTQ0IBRioZAt5WDeCSMiC9HlfRu4ucAHPKEi3iS287D0mjZC0lkenbViaqP8sKLr6RgcYZBMqwAorKkduLC1MSOhpZBm1uZAESuWD9GLXZAfnXyAZAE5o5p3UEupCAUoZBaUcdsrcKJpoQxRiw8HRvBFFSLDjX75hs2YZBrcVfYuXy5HoOlsRKCDtwzN6Gu402zTM239XgCcCAI',
  instagramUserId: '17841430181976892',

  // Supabase (self-hosted — gleiche Instanz wie Gravity)
  supabaseUrl: 'https://systems.stonewavetech.com/_sb',
  supabaseAnonKey: 'eyJhbGciOiAiSFMyNTYiLCAidHlwIjogIkpXVCJ9.eyJyb2xlIjogImFub24iLCAiaXNzIjogInN1cGFiYXNlIiwgImlhdCI6IDE3ODEzNDYyOTksICJleHAiOiAyMDk2NzA2Mjk5fQ.2Jwl1lzg5_5Dyo93Y5U8UZaa-o3b5whS05FzQSX77NM',

  // Cloudflare R2 (wird durch Supabase Storage ersetzt)
  r2AccountId:        '1bde1876442e88111e467ab534948d1d',
  r2AccessKeyId:      'f217daf83996f5a317e3aea3980f9d3a',
  r2SecretAccessKey:  '7b723cb9cfe16b6162c693b899c77f364a4f285a3bcf41d34d96de5b29b7e1b3',
  r2BucketName:       'gravity-cloud',
  r2PublicUrl:        'https://pub-b0e9a48fedf84ddea43b714a3afd5390.r2.dev',
  r2ContentPublicUrl: 'https://content.stonewavetech.com',

  // Reel Render Server
  reelRenderUrl: 'http://localhost:3100',

  // MiniMax TTS (Pay-as-you-go Audio Plan)
  minimaxTtsKey:   '',
  // MiniMax Music (Token Plan)
  minimaxMusicKey: '',

  // Prism — Content Pipeline
  prismPublishUrl: 'https://prism-publish.stonewavetech.workers.dev',
  prismSecret:     '32014a01d102d6dfc0624d58b1b421a3418853179fe925c8e9f87802f6b1b65e',
};
